import script from "./MobileDispatchPendingHint.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileDispatchPendingHint.vue?vue&type=script&setup=true&lang=js"

import "./MobileDispatchPendingHint.vue?vue&type=style&index=0&id=d406e250&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d406e250"]])

export default __exports__